import React, { memo } from "react";
import styled from "styled-components";

interface ICommercialTextProps {
  text: string;
}

export const TextDisplay = styled.div`
  color: ${(props) => props.theme.textColorDarken};
  font-size: 12px;
  white-space: break-spaces;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`;

const Text = (props: ICommercialTextProps) => {
  const mappedText = props.text.split("\r\n").join("</br>");
  return (
    <TextDisplay>
      <span dangerouslySetInnerHTML={{ __html: mappedText }} />
    </TextDisplay>
  );
};

export const CommercialText = memo(Text);
